import React from 'react';

import classes from '@nerdwallet/base-styles/classes';
import { Box } from '@nerdwallet/currency/components/Box';
import { Text } from '@nerdwallet/currency/components/Text';

import LockLabel from '@components/lock-label';
import { SegmentEventViewed } from '@lib/segment';

import AppDownloadFooter from '../app-download-footer';
import { CREDIT_FACTOR_ORDER, creditFactorConfig } from './constants';

const CreditFactorsLocked: React.FC = () => (
  <>
    <Text bold size="large">
      Credit factors
    </Text>
    <Box
      backgroundColor={{ desktop: 'yellow-lightest' }}
      marginTop="3"
      padding={{ desktop: '3', mobile: '0' }}
    >
      {CREDIT_FACTOR_ORDER.map((factorName, i) => {
        const { displayName, impactLevel, segmentEventPrefix } =
          creditFactorConfig[factorName];

        return (
          <SegmentEventViewed
            eventName={`${segmentEventPrefix} Tile Viewed`}
            key={factorName}
          >
            <Box
              alignItems="center"
              backgroundColor="white"
              borderColor="neutral-lighter"
              className={
                i === 0
                  ? classes('border-top-1', 'border-top-0--wide')
                  : classes('border-top-1')
              }
              display="flex"
              justifyContent="space-between"
              padding="3"
            >
              <Box display="flex" flexDirection="column">
                <Text>{displayName}</Text>
                <Text light size="small">
                  {impactLevel}
                </Text>
              </Box>
              <Box
                alignItems="center"
                display={{ desktop: 'flex', mobile: 'none' }}
              >
                <LockLabel
                  containerStyle={{
                    maxWidth: '200px',
                    backgroundColor: 'transparent',
                  }}
                  labelText="available in the app"
                />
              </Box>
            </Box>
          </SegmentEventViewed>
        );
      })}
    </Box>
    <AppDownloadFooter />
  </>
);

export default CreditFactorsLocked;
